export default "__VITE_ASSET__sc36cDL6__"